"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StripeCardElement;
var _react = _interopRequireDefault(require("react"));
var _reactStripeJs = require("@stripe/react-stripe-js");
var _label = _interopRequireDefault(require("./label"));
var _formGroup = _interopRequireDefault(require("./form-group"));
var _col = _interopRequireDefault(require("./col"));
var _rowConfig = _interopRequireDefault(require("./row-config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Card Number");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "CVC");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Card Expiry");
function StripeCardElement({
  disabled
}) {
  return /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
    columns: [{
      sm: 4,
      md: 3
    }, {
      sm: 8,
      md: 9
    }]
  }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardNumberElement, {
    options: {
      disabled,
      disableLink: true,
      classes: {
        base: 'form-control'
      }
    }
  }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardCvcElement, {
    options: {
      disabled,
      classes: {
        base: 'form-control'
      }
    }
  }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardExpiryElement, {
    options: {
      disabled,
      classes: {
        base: 'form-control'
      }
    }
  }))));
}

// TODO: Apple Pay:
//  - https://stripe.com/docs/stripe-js/elements/payment-request-button
//  - https://github.com/stripe/react-stripe-elements#using-the-paymentrequestbuttonelement